var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "display-elements" }, [
    _vm.content.bottlesize && _vm.content.bottlesize.length > 0
      ? _c("div", { staticClass: "display-element bottle-display" }, [
          _c(
            "div",
            { staticClass: "item-element" },
            [_c(_vm.sizeIcon, { tag: "component", staticClass: "icon" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "item-element" }, [
            _c("div", { staticClass: "item-sub-element" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v("\n          " + _vm._s(_vm.sizeLabel) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-sub-element" }, [
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.content.bottlesize) + "\n        "
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.content.winebody &&
    _vm.content.winebody.length > 0 &&
    _vm.content.winebody != "unknown"
      ? _c("div", { staticClass: "display-element bottle-display" }, [
          _c(
            "div",
            { staticClass: "item-element" },
            [_c(_vm.bodyIcon, { tag: "component", staticClass: "icon" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "item-element" }, [
            _c("div", { staticClass: "item-sub-element" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v("\n          " + _vm._s(_vm.bodyLabel) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-sub-element" }, [
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.content.winebody) + "\n        "
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.content.wine_type && _vm.content.wine_type.length > 0
      ? _c("div", { staticClass: "display-element wine-type" }, [
          _c(
            "div",
            { staticClass: "item-element" },
            [_c(_vm.typeIcon, { tag: "component", staticClass: "icon" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "item-element" }, [
            _c("div", { staticClass: "item-sub-element" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v("\n          " + _vm._s(_vm.typeLabel) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-sub-element" }, [
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.content.wine_type) + "\n        "
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.content.varietal && _vm.content.varietal.length > 0
      ? _c("div", { staticClass: "display-element wine-varietal" }, [
          _c(
            "div",
            { staticClass: "item-element" },
            [_c(_vm.varietalIcon, { tag: "component", staticClass: "icon" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "item-element" }, [
            _c("div", { staticClass: "item-sub-element" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.varietalLabel) + "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-sub-element" }, [
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.content.varietal.join(", ")) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }